import TablePage from './TablePage.vue'

export default TablePage
